import _get from 'lodash/get';
import _memoize from 'lodash/memoize';
import React, { useEffect } from 'react';
import intl from 'react-intl-universal';
import Icon from 'components/Common/Icon';
import SearchBar from 'components/Search/SearchBar';
import InfiniteTable from 'containers/InfiniteTable/InfiniteTableContainer';
import RoomSystemsToolBar from 'containers/RoomSystems/RoomSystemsToolbarContainer';
import { RoomSystem } from 'typings/types';
import ListViewLayout from 'components/ListViewLayout/ListViewLayout';
import { roomSystemColumnConfig, transformRoomSystemData } from './RoomSystemColumnConfig';
import useListHooks from 'hooks/useListHooks';
import listRoomsQuery from 'queries/roomSystems/listRoomsQuery.gql';
import { SortDirection } from 'constants/queryConstants';

interface Props {
  selectionArray: Array<string>;
  resetExportState: () => void;
}

const getTitle = _memoize(() => {
  return (
    <>
      <Icon classes={['icon-room-system']} />
      <span>{intl.get('roomSystems')}</span>
    </>
  );
});

const RoomSystemsComponent = (props: Props) => {
  const { resetExportState, selectionArray } = props;
  const {
    loading,
    data,
    error,
    setFilterString,
  } = useListHooks(listRoomsQuery, { propertyName: 'systemName', direction: SortDirection.DESC });

  useEffect(() => {
    resetExportState();
  },        []);

  const directoryListRoomSystem = _get(data, 'directoryListRoomSystem');
  let listData = (!loading && directoryListRoomSystem)
    ? directoryListRoomSystem.records as unknown as RoomSystem[]
    : [];

  if (listData && listData.length) {
    listData = listData.filter((rs) => rs.serialNumber);
    listData = transformRoomSystemData(listData);
  }

  return (
    <ListViewLayout
      title={getTitle()}
      isFetching={false}
      error={_get(error, 'message')}
      numberOfPages={0}
    >
      <InfiniteTable
        columnConfig={roomSystemColumnConfig()}
        data={listData}
        defaultSort={[
          {
            id: 'systemName',
            desc: false
          },
        ]}
        loading={loading}
        keyField={'serialNumber'}
        renderHeader={() => (
          <>
            <SearchBar
              setFilterString={setFilterString}
            />
            <RoomSystemsToolBar
              data={data}
              selectionArray={selectionArray}
            />
          </>
        )}
        rowHeightOverride={48}
        sortable={true}
        manual={true}
        enableSelect={true}
        getTrProps={() => {
          return {
            style: {
              height: '48px'
            }
          };
        }}
        usePageSize={true}
      />
    </ListViewLayout>
  );
};

export default RoomSystemsComponent;
